import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  subtitle: {
    marginTop: '5px',
  },
  button: {
    marginLeft: '10px',
  },
  cancelButton: {
    backgroundColor: '#EDEDED',
    color: '#212322',
    '&&:hover': {
      backgroundColor: '#EDEDED',
    }
  },
  previewButton: {
    backgroundColor: '#00A1A1',
    color: '#FFFFFF',
    '&&:hover': {
      backgroundColor: '#00A1A1',
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    }
  },
  titleWrapper: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
    '&& > h2': {
      fontWeight: 400
    }
  },
});


export const WebsitesEditStepActions = withStyles(styles)(({classes, title, disabled, id}) => (
  <Grid container spacing={3} alignItems="flex-start">
    <Grid item xs={12} sm={5} lg={4} className={classes.titleWrapper}>
      <Typography variant="h6">
        {title}
      </Typography>
      <Typography className={classes.subtitle} variant="body2">
        {`Customize your ${title}`}
      </Typography>
    </Grid>
    <Grid item xs={12} sm={7} lg={8} className={classes.buttons}>
      <Button
        className={`${classes.button} ${classes.cancelButton}`}
        data-testid="template-edit-cancel-button"
        component={Link}
        to={`/websites/${encodeURIComponent(id)}`}
      >
        CANCEL
      </Button>
      {/*<Button className={`${classes.button} ${classes.previewButton}`}>*/}
      {/*Preview*/}
      {/*</Button>*/}
      <Button
        color="secondary"
        variant="contained"
        className={`${classes.button} consent-edit-saveandpublish-button`}
        type="submit"
        data-testid="template-edit-save-publish-button"
        disabled={disabled}
      >
        Save & publish
      </Button>
    </Grid>
  </Grid>
));

